<template>
  <div class="pay-result-page">
    <pageHeader title="支付结果" />
    <div class="gray-box"></div>

    <div class="result">
      <van-circle
        v-model="percentage"
        :rate="percentage"
        size="125px"
        color="#ff7a3e"
        :text="runtimeText"
        :clockwise="false"
      />
      <!-- <img :src="payResultIcon[status]" alt="" /> -->
      <p >{{ payResultText }}</p>
      <span>{{ total_amount }}</span>

      <div class="go-home" @click="goHome">立即跳转</div>
    </div>
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import { requestMethods } from "@m/api";
export default {
  components: {
    pageHeader,
  },
  data() {
    return {
      status: "pending", // 支付状态：pending, success, fail
      tradeNo: "", // 支付宝交易号
      payResultIcon: {
        pending: require("@/assets/images/ic_detail_status_ing.png"),
        success: require("@/assets/images/ic_detail_status_ok.png"),
        fail: require("@/assets/images/ic_detail_status_fail.png"),
      },
      total_amount: "",
      // payResultText: {
      //   pending: "请稍等，充值中...",
      //   success: "充值成功",
      //   fail: "充值失败",
      // },
      payResultText: "",
      percentage: 100,
      totalTime: 3, // 总倒计时时间（秒）
      remainingTime: 3,
      runtimeText: "3",
      timer: null,
      queryPath: {},
      payway: ''
    };
  },
  mounted() {
    this.startCountdown();
    this.handlePaymentResult();
    // this.getPayStatus()
  },
  methods: {
    startCountdown() {
      this.timer = setInterval(() => {
        this.remainingTime--;
        this.percentage = (this.remainingTime / this.totalTime) * 100;
        this.runtimeText = String(this.remainingTime);

        if (this.remainingTime <= 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    // 处理支付结果
    handlePaymentResult() {
      const { payway, amount } = this.$route.query;
      this.payway = payway
      if (payway == "balance") {
        this.total_amount = `充值金额￥${amount}`;
        this.payResultText = "充值成功";
        setTimeout(() => {
          clearInterval(this.timer);
          this.$router.replace({
            path: "/rechargeRecord",
          });
        }, 1500);
      } else {
        this.alipaymentResult();
      }
    },

    /**
     * 支付宝支付结果处理
     */
    async alipaymentResult() {
      const query = this.$route.query; // 获取路由参数

      // 示例：支付宝可能返回的查询参数
      const outTradeNo = query.out_trade_no;

      this.tradeNo = outTradeNo; // 保存交易号
      let payRouter = JSON.parse(localStorage.getItem('payRouter'))

      let queryPath = {}

      if(payRouter == 'accountTrade') {
        queryPath = { path: '/tradeRecord', query: { pageTab: 1 } }
      } else if(payRouter == 'monthCard') {
        queryPath = { path: '/signCard' }
      } else if(payRouter == 'balance') {
        queryPath = { path: '/balance' }
      } else {
        queryPath = { path: "/rechargeRecord" }
      }
      this.queryPath = queryPath
      
      // 根据支付宝返回的 trade_status 判断支付状态
      if (this.tradeNo) {
        await this.getPayStatus();
        // this.status = "success"; // 支付成功
        // 停止倒计时
        clearInterval(this.timer);
        setTimeout(() => {
          this.$router.replace(this.queryPath);
        }, 1500);
      }
    },
    /**
     * 查询订单状态 2409251417683735
     */
    async getPayStatus() {
      const RECHARGE_AMOUNT = JSON.parse(sessionStorage.getItem('RECHARGE_AMOUNT')) || ''
      try {
        const { msg } = await requestMethods(
          "/modules/RechargeAction/getRechargeStatus.htm",
          "post",
          {
            orderNo: this.tradeNo,
            rechargeType: 'NEW_RECHARGE'
          }
        );
        this.total_amount = `充值金额￥${RECHARGE_AMOUNT}`;
        this.payResultText = msg;
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },

    // 返回首页
    goHome() {
      if(this.payway == 'balance') {
        this.$router.replace({
          path: "/rechargeRecord",
        });
      } else {
        let payRouter = JSON.parse(localStorage.getItem('payRouter'))

        let queryPath = {}

        if(payRouter == 'accountTrade') {
          queryPath = { path: '/tradeRecord', query: { pageTab: 1 } }
        } else if(payRouter == 'monthCard') {
          queryPath = { path: '/signCard' }
        } else if(payRouter == 'balance') {
          queryPath = { path: '/balance' }
        } else {
          queryPath = { path: "/rechargeRecord" }
        }
      this.$router.replace(queryPath);
      }
      
    },
  },
};
</script>

<style lang="scss">
.pay-result-page {
  .gray-box {
    width: 100%;
    height: 20px;
    background: #f5f5f5;
  }
  .result {
    text-align: center;
    margin: 0 auto;

    .van-circle {
      margin-top: 110px;

      .van-circle__text {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 80px;
        color: #212121;
        line-height: 112px;
      }
    }

    img {
      width: 110px;
      height: 110px;
      margin-top: 60px;
    }
    p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 28px;
      color: #212121;
      margin-top: 43px;
      margin-bottom: 6px;
    }
    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 26px;
      color: #666666;
      line-height: 37px;
    }
    .go-home {
      width: 300px;
      height: 80px;
      margin-left: 225px;
      background: url(~@/assets/images/recharge_btn.png);
      background-size: 100% 100%;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 36px;
      color: #ffffff;
      margin-top: 95px;
      line-height: 80px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/payResult/index.vue